// The Clinic ID rules (API.md §3.1, §7.3): checked here for quick feedback; the server is authoritative.

/** API.md §7.3's reserved words (the longer list; T-U-SLUG-01). */
export const RESERVED_SLUGS = [
  'admin',
  'api',
  'app',
  'www',
  'c',
  'static',
  'embed',
  'health',
  'ready',
  'internal',
  'v1',
  'public',
] as const

export const SLUG_RE = /^[a-z0-9](?:[a-z0-9-]{1,38}[a-z0-9])$/

export type SlugProblem = 'slug_invalid' | 'slug_reserved' | null

export function slugProblem(slug: string): SlugProblem {
  if (!SLUG_RE.test(slug)) return 'slug_invalid'
  if ((RESERVED_SLUGS as readonly string[]).includes(slug)) return 'slug_reserved'
  return null
}

/** A suggested Clinic ID from the clinic name ("Primary Care of Clear Lake" → "primary-care-of-clear-lake"). */
export function suggestSlug(name: string): string {
  return name
    .toLowerCase()
    .normalize('NFKD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 40)
    .replace(/-+$/g, '')
}
